import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-sadhana-shiledar',
  templateUrl: './online-sadhana-shiledar.component.html',
  styleUrls: ['./online-sadhana-shiledar.component.scss']
})
export class OnlineSadhanaShiledarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
